import { render } from "./MovementDetailView.vue?vue&type=template&id=0e427794&scoped=true"
import script from "./MovementDetailView.vue?vue&type=script&lang=js"
export * from "./MovementDetailView.vue?vue&type=script&lang=js"

import "./MovementDetailView.vue?vue&type=style&index=0&id=0e427794&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e427794"]])

export default __exports__